import(/* webpackMode: "eager", webpackExports: ["RentContent"] */ "/var/www/azia_frontv2_green/src/app/rent/rent-content.tsx");
